import { render, staticRenderFns } from "./MatchHistoryHeader.vue?vue&type=template&id=b8074508&scoped=true&"
import script from "./MatchHistoryHeader.vue?vue&type=script&lang=js&"
export * from "./MatchHistoryHeader.vue?vue&type=script&lang=js&"
import style0 from "./MatchHistoryHeader.vue?vue&type=style&index=0&id=b8074508&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8074508",
  null
  
)

export default component.exports